<vectronic-filter-header
  [title]="title()"
  (titleClicked)="toggled.emit()"
  (enabledFilterToggle)="toggled.emit()"
  [isFilterEnabled]="expanded()"
></vectronic-filter-header>
<div class="min-max-filter" [hidden]="!expanded()">
  @for (key of getKeys(); track key) {
    @if (options()?.[key]?.label) {
      <label class="filter-label">{{ options()?.[key]?.label }}</label>
    }
    <div class="filter-container">
      <div class="input-column">
        <mat-form-field appearance="outline" class="input-form">
          <mat-label>Min</mat-label>
          <input
            matInput
            type="number"
            [min]="options()?.[key]?.min"
            [max]="options()?.[key]?.max"
            [value]="getValue(key, 'min')"
            (input)="onFilterChange(key, 'min', $event)"
          />
        </mat-form-field>
        @if (isOptionInvalid(key, 'min'); as error) {
          <div class="error-message">{{ error }}</div>
        }
      </div>
      <div class="input-column">
        <mat-form-field appearance="outline" class="input-form">
          <mat-label>Max</mat-label>
          <input
            matInput
            type="number"
            [min]="options()?.[key]?.min"
            [max]="options()?.[key]?.max"
            [value]="getValue(key, 'max')"
            (input)="onFilterChange(key, 'max', $event)"
          />
        </mat-form-field>
        @if (isOptionInvalid(key, 'max'); as error) {
          <div class="error-message">{{ error }}</div>
        }
      </div>
    </div>
    @if (isRangeInvalid(key)) {
      <div class="error-message">Min > Max</div>
    }
  }
</div>
